import Vue from 'vue'
import 'babel-polyfill';

import '@/assets/style/index.less' // global css
import "vue-waterfall-plugin/dist/style.css"

import App from './App'
import router from './router'

import '@/permission' // permission control

import message from "@/components/message";
import artwork from "@/components/artwork";

import store from './store';



Vue.prototype.$color = "black";
Vue.prototype.$message = message;
Vue.prototype.$artwork = artwork;
Vue.prototype.$vue = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
});

// Vue.prototype.$EventBus = new Vue();





// WEBPACK FOOTER //
// ./src/main.js